import { Sector } from "recharts"
import "./styles.scss"
import { Popover } from '@headlessui/react'
import { isJson } from "../../core/utils/jsonVerify"
import { Tooltip } from 'antd';
import { memo } from "react";

export const CustomTooltip = ({ active, payload, labelValue }) => {
  const tooltipType = (payload = {}) => {
    return (
      <>
        {payload?.user && <><br />
        <br />
        {payload?.user ? payload.user?.name : payload?.name}</>}
        <br />
        <>
        <br />
        {!labelValue ? "Valor: " : `${labelValue}: `}{payload?.user ? payload.user?.value : payload.value}
        </>
        <br />
        {payload?.reference && `Referência: ${payload?.reference}`}
        {payload?.user &&
          payload?.user?.positiveVariation > 0 &&
          `Desvio Padrão: ${(payload?.user?.positiveVariation - payload?.user?.value).toFixed(2) || 0
          }`}
        {payload?.user &&
          payload?.user?.numNps > 0 &&
          `Número de Respostas : ${payload?.user?.numNps || 0}`}
      </>
    )
  }

  if (active && payload && payload.length) {
    return (
      <div className="tooltip-info">
        <p className="tooltip-info-value">{tooltipType(payload[0]?.payload || {})}</p>
      </div>
    )
  }
  return <div></div>
}

export const CustomTooltipAreaESM = ({ active, payload, labelValue }) => {
  
  const tooltipType = (obj) => {
    const { payload } = obj

    const bioOrEco = payload['Biológico'] && `Biológico: ${payload['Biológico']}`;
    const chemicalOrhuman = payload['Químico'] && `Químico: ${payload['Químico']}`;
    const general = payload['Geral'] && `Geral: ${payload['Geral']}`;
    const producer = `Amostra: ${payload?.user?.email}` 
    return (
      <>
        <br />
        {producer}
        <br/>
        {general}
        <br />
        {bioOrEco}
        <br />
        {chemicalOrhuman}
      </>
    )
  }

  if (active && payload && payload.length) {
    return (
      <div className="tooltip-info" style={{background: "#FFF"}}>
        <p className="tooltip-info-value" style={{color: "#000"}}>{tooltipType(payload[0])}</p>
      </div>
    )
  }
  return null
}

export const CustomTooltipBarometer = ({ active, payload, labelValue, ...props }) => {
  const tooltipType = (obj) => {
    const { payload, name } = obj

    const newName = Array.isArray(payload?.user) && payload?.user[0]?.email;

    const bioOrEco = name?.summary?.hasOwnProperty("Biológico") ? `Biológico: ${payload?.x}` : `Bem estar ecológico: ${payload?.x}`
    const quimicOrhuman = name?.summary?.hasOwnProperty("Químico") ? `Químico: ${payload?.y}` : `Bem estar humano: ${payload?.y}`
    const producer = (payload && payload?.user && payload?.user.length > 0) ? `Produtor: ${payload?.user[0]?.name}` : ``
    
    return (
      <>
        <br />
        {producer && <>{producer}<br /></>}
        {bioOrEco}
        <br />
        {quimicOrhuman}
      </>
    )
  }

  if (active && payload && payload.length) {
    return (
      <div className="tooltip-info" style={{background: "#FFF"}}>
        <p className="tooltip-info-value" style={{color: "#000"}}>{tooltipType(payload[0])}</p>
      </div>
    )
  }
  return null
}

export const RenderActiveShape = (props) => {
  let value = ""
  let percent = ""

  value = props?.showOnlyName
    ? props?.tooltipPayload[0]?.payload?.name
    : props?.tooltipPayload[0]?.payload?.value || value

  value = props?.noLabels ? "" : props?.tooltipPayload[0]?.payload?.value || value

  percent = props?.noLabels ? "" : props?.percent


  const RADIAN = Math.PI / 180
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload } = props
  const sin = Math.sin(-RADIAN * midAngle)
  const cos = Math.cos(-RADIAN * midAngle)
  const sx = cx + (outerRadius + 10) * cos
  const sy = cy + (outerRadius + 10) * sin
  const mx = cx + (outerRadius + 30) * cos
  const my = cy + (outerRadius + 30) * sin
  const ex = mx + (cos >= 0 ? 1 : -1) * 22
  const ey = my
  const textAnchor = cos >= 0 ? "start" : "end"
  

  return (
    <g>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={props.noLabels ? 0 : outerRadius + 10}
        fill={fill}
      />
      {percent != "" && (
        <>
          <path d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`} stroke={fill} fill="none" />
          <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
          <foreignObject
            x={ex + (cos >= 0 ? 1 : -150)}
            y={ey + (cos >= 0 ? 1 : -15)}
            width="200"
            height="200"
            fontSize="12px"
            className="tooltip-obj">
            <div className="tooltip-area-text">
              
              <text
              className="tooltip-area-text-percent"
              x={ex + (cos >= 0 ? 1 : -1) * 12}
              y={ey}
              dy={20}
              textAnchor={textAnchor}
              fontSize="10px"
              fill="#999">
              {percent ? <strong>{`(${(percent * 100).toFixed(2)}%)`} {`${value}`}</strong> : value}
            </text>
            <text
              className="tooltip-area-text-percent"
              x={ex + (cos >= 0 ? 1 : -1) * 12}
              y={ey}
              dy={18}
              textAnchor={textAnchor}
              fontSize="10px"
              fill="#999">
              {` - ${props.value}`}
            </text>
            </div>
            
          </foreignObject>
        </>
      )}
    </g>
  )
}

export const CustomTooltipBar = ({ active, payload, label, journey }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <text className="label">{label}</text>
        <div className="div-list-tooltip">
          {payload.map((item) => {
            return (
              <div className="row-list">
                {item.dataKey.includes(".goal") ? (
                  <div
                    style={{ backgroundColor: item.color, borderRadius: "100%" }}
                    className="legend"
                  />
                ) : (
                  <div style={{ backgroundColor: item.color }} className="legend" />
                )}
                <text style={{ color: item.color }} className="text-legend">
                  {item.dataKey.includes(".goal") ? "META " : ""}
                  {item.dataKey.split("[0]")[0]}:{" "}
                </text>
                <text style={{ color: item.color }} className="text-legend">
                  {item.dataKey.includes(".goal") ? 
                    (item?.payload[item.dataKey.split("[0]")[0]][0]?.goal || 0) : 
                    journey ? 
                    `${item?.payload[item.dataKey.split("[0]")[0]][0]?.number} (${item.value}%)` :
                    item.value
                  }
                </text>
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  return null
}

export const ReactCustomTooltip = ({children, labelbutton, className}) => {
  return (
    <Popover>
      <Popover.Button className={`custom-popover-button ${className ? className : ""}`}>{labelbutton}</Popover.Button>
      <Popover.Panel className="custom-popover">
      <div className="custom-popover-content">
      {children}
      </div>
      </Popover.Panel>
    </Popover>
  )
};

export const InfoTooltip = memo(({children, info, icon = "fi-rr-comment-info", iconColor = "#99AA99", className, placement = "bottom", trigger = "hover", fontSize = 16}) => {
  return <Tooltip
      placement={placement}
      trigger={trigger}
      style={{zIndex: 999999}}
      mouseLeaveDelay={0}
      mouseEnterDelay={0}
      title={info}>
      {children ? children : <i className={`fi ${icon} ${className}`} style={{color: iconColor?.includes("#") ? iconColor : `#${iconColor}`, fontSize: fontSize}} />}
    </Tooltip>
});

